import { memo, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { Stepper, Tag } from '@didaskill/ui/design-system';

import { assignmentStepperMessages } from '../AssignmentStepper.messages';
import { ASSIGNMENT_STEP_ICONS_MAP, ASSIGNMENT_STEPS } from '../constants';

type AssignmentStepProps = {
  isDone: boolean;
  step: ASSIGNMENT_STEPS;
  isCurrent: boolean;
};

const AssignmentStepBase = ({ isDone, isCurrent, step }: AssignmentStepProps) => {
  const tagVariant = useMemo(() => {
    if (isDone) return Tag.VARIANTS.SUCCESS;

    if (isCurrent) return Tag.VARIANTS.PRIMARY;

    return Tag.VARIANTS.NEUTRAL;
  }, [isCurrent, isDone]);

  return (
    <Stepper.Step
      variant={Stepper.VARIANTS.HORIZONTAL}
      isDone={isDone}
      isCurrent={isCurrent}
      isTagHidden
      isLabelHidden
      icon={ASSIGNMENT_STEP_ICONS_MAP[step]}
      isLast={[ASSIGNMENT_STEPS.CORRECTED, ASSIGNMENT_STEPS.ORAL_DONE].includes(step)}
    >
      <Tag
        size={Tag.SIZES.SMALL}
        light
        variant={tagVariant}
        label={<FormattedMessage {...assignmentStepperMessages[step]} />}
      />
    </Stepper.Step>
  );
};

export const AssignmentStep = memo(AssignmentStepBase);
